import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import AccountLayout from 'src/layouts/account';
import EcommerceLayout from 'src/layouts/ecommerce';
import ProtectedRoute from 'src/components/auth/protected-route';

// ----------------------------------------------------------------------

const CartPage = lazy(() => import('src/pages/e-commerce/cart'));
const ComparePage = lazy(() => import('src/pages/e-commerce/compare'));
const LandingPage = lazy(() => import('src/pages/e-commerce/landing'));
const ProductDetailsPage = lazy(() => import('src/pages/e-commerce/product-details'));
const CheckoutPage = lazy(() => import('src/pages/e-commerce/checkout'));
const ProductsPage = lazy(() => import('src/pages/e-commerce/products'));
const WishlistPage = lazy(() => import('src/pages/e-commerce/wishlist'));
const OrderCompletedPage = lazy(() => import('src/pages/e-commerce/order-completed'));
const ProductAddPage = lazy(() => import('src/pages/product-add'));
const LoginPage = lazy(() => import('src/pages/login'));

const AccountOrdersPage = lazy(() => import('src/pages/e-commerce/account/orders'));
const AccountPaymentPage = lazy(() => import('src/pages/e-commerce/account/payment'));
const AccountPersonalPage = lazy(() => import('src/pages/e-commerce/account/personal'));
const AccountVouchersPage = lazy(() => import('src/pages/e-commerce/account/vouchers'));
const AccountWishlistPage = lazy(() => import('src/pages/e-commerce/account/wishlist'));

// ----------------------------------------------------------------------

export const eCommerceRoutes = [
  {
    path: '/',
    element: (
      <EcommerceLayout>
        <Outlet />
      </EcommerceLayout>
    ),
    children: [
      { element: <LandingPage />, index: true },
      { path: 'san-pham', element: <ProductsPage /> },
      { path: 'san-pham/:id', element: <ProductDetailsPage /> },
      {
        path: 'them-san-pham',
        element: (
          <ProtectedRoute>
            <ProductAddPage />
          </ProtectedRoute>
        ),
      },
      { path: 'gio-hang', element: <CartPage /> },
      { path: 'thanh-toan', element: <CheckoutPage /> },
      { path: 'dat-hang-thanh-cong', element: <OrderCompletedPage /> },
      { path: 'danh-sach-yeu-thich', element: <WishlistPage /> },
      { path: 'so-sanh', element: <ComparePage /> },
      {
        path: 'tai-khoan',
        element: (
          <AccountLayout>
            <Outlet />
          </AccountLayout>
        ),
        children: [
          { path: 'ca-nhan', element: <AccountPersonalPage /> },
          { path: 'yeu-thich', element: <AccountWishlistPage /> },
          { path: 'ma-giam-gia', element: <AccountVouchersPage /> },
          { path: 'don-hang', element: <AccountOrdersPage /> },
          { path: 'thanh-toan', element: <AccountPaymentPage /> },
        ],
      },
    ],
  },
  {
    path: 'dang-nhap',
    element: <LoginPage />,
  },
];
